<template>
  <form class="form">
    <h2>Образование</h2>

    <fieldset class="form form--fieldset" disabled>
      <div class="form__group">
        <t-text :model-value="store.application.diploma?.education_type || 'Не указано'" label="Имеющееся образование"/>
        <t-text :model-value="String(store.application.diploma?.education_year || 'Не указано')" label="Год получения образования"/>
      </div>

      <div class="form__group">
        <t-text :model-value="store.application.diploma?.series || 'Не указано'" label="Серия"/>
        <t-text :model-value="store.application.diploma?.number || 'Не указано'" label="Номер"/>
      </div>

      <div class="form__group">
        <t-text-growing :model-value="store.application.diploma?.document_type || 'Не указано'" label="Документ об образовании"/>
      </div>

      <hr>

      <h2>Место получения образования</h2>

      <div class="form__group">
        <t-text-growing :model-value="store.application.diploma?.contragent || 'Не указано'" label="Образовательное учреждение"/>
      </div>

      <div class="form__group">
        <t-text :model-value="store.application.diploma?.average_grade || 'Не указано'" label="Средний балл"/>
      </div>
    </fieldset>
  </form>
</template>

<script setup>
import { TText, TTextGrowing } from '@shared/ui'
import { useApplicationStore } from '@widgets/application-profile'

const store = useApplicationStore()
</script>
